import {Component, HostListener, OnDestroy} from "@angular/core";
import {FUIOptionsService} from "../../../framework/options.service";
import {Subscription} from "rxjs";
import {FUIAbstractOption} from "../../../framework/abstract-option";

@Component({
    selector: "fui-autocomplete-option",
    styleUrls: ["./autocomplete-option.component.scss"],
    templateUrl: "./autocomplete-option.component.html",
    standalone: false
})
export class FUIAutocompleteOptionComponent extends FUIAbstractOption implements OnDestroy {
    private _$selection: Subscription;

    constructor(optionsService: FUIOptionsService) {
        super(optionsService);
        this.tabindex = 0;
    }

    ngOnInit(): void {
        this._$selection = this.optionsService.selection$.subscribe(
            (selection) => {
                if (selection) {
                    if (selection[this.field]) {
                        if (this.option[this.field] === selection[this.field]) {
                            if (this.option) {
                                this._valued = true;
                            }
                        }
                        else {
                            this._valued = false;
                        }
                    }
                }
                else {
                    this._valued = false;
                }
            }
        )
    }

    ngOnDestroy(): void {
        this._$selection.unsubscribe();
    }

    /**
     * Set option as active in service
     */
    @HostListener("click")
    public click(): void {
        this.optionsService.selection = this.option;
    }

    /**
     * Run the click action on keypress of enter or space
     * @param {KeyboardEvent} keyboardEvent
     */
    @HostListener("keypress", ["$event"])
    public keypress(keyboardEvent: KeyboardEvent): void {
        if (keyboardEvent.code === "Enter" || keyboardEvent.code === "Space" || keyboardEvent.key === "Enter" || keyboardEvent.key === " ") {
            this.click();
            keyboardEvent.preventDefault();
            keyboardEvent.stopPropagation();
        }
    }
}
